<template>
  <page>
    <page-error :message="$t('ErrorPage_Forbidden')" />
  </page>
</template>

<script>
import Page from '@/common/components/page/Page'
import PageError from '@/common/components/page/PageError'

export default {
  name: 'ForbiddenPage',
  components: { PageError, Page }
}
</script>



// WEBPACK FOOTER //
// src/modules/errors/pages/ForbiddenPage.vue